module.exports = "https://cdn.realtymogul.com/static/media/MRI.5e288166.jpg";